import React from 'react';
import { useTranslation } from 'next-i18next';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Separator,
  Button,
} from '@lb-classroom/ui';
import { X } from 'lucide-react';
import { SingleDatePicker } from 'react-dates';
import ModalMessage from '@components/UI/organisms/ModalMessage';
import type { EditShiftSetModalProps } from './edit-shift-set-modal.types';

export const EditShiftSetModal = ({
  isSubmitting,
  durationEnd,
  focusedOnDurationEnd,
  message,
  messageType,
  onDurationEndChange,
  onFocusChange,
  onSubmit,
  onClose,
}: EditShiftSetModalProps) => {
  const { t } = useTranslation('common');

  return (
    <div className="max-w-lg mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>{t('modals.editShiftSet.title')}</CardTitle>
          <button type="button" className="modal-close" onClick={onClose}>
            <span className="sr-only">{t('buttons.close')}</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <ModalMessage message={message} messageType={messageType} />
          <form
            method="put"
            className="report-and-resolve-issue-form"
            onSubmit={onSubmit}
            noValidate
          >
            <div>
              <div className="mb-8 date-picker-relative">
                <p>{t('modals.editShiftSet.description')}</p>
                <h5>{t('modals.editShiftSet.durationEndLabel')}</h5>
                <SingleDatePicker
                  id="duration_end_of_set_input"
                  date={durationEnd}
                  numberOfMonths={1}
                  focused={focusedOnDurationEnd}
                  onDateChange={(date) => onDurationEndChange(date)}
                  onFocusChange={({ focused }) => onFocusChange(focused)}
                />
                <Separator className="my-4" />
              </div>
            </div>
            <Separator className="my-4" />
            <div className="text-right">
              <Button type="submit" size="lg" disabled={isSubmitting}>
                {t('modals.editShiftSet.update')}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
